import { Link } from "react-router-dom";
import { formatDate } from "@/lib/articles";
import type { Article } from "@/mocks/articles";

interface StarCardProps {
  article: Article;
}

export default function StarCard({ article }: StarCardProps) {
  return (
    <article className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-200 hover:bg-accent-50/50">
      <Link
        to={`/detail/${article.id}`}
        className="relative h-16 w-16 shrink-0 overflow-hidden rounded-full md:h-20 md:w-20"
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 蜜桃33`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-user-star-line text-accent-600" />
          <span className="whitespace-nowrap">{article.tags[0] ?? article.categoryName}</span>
          <span className="whitespace-nowrap">· {formatDate(article.publishedAt)}</span>
        </div>
        <h3 className="mt-1.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 md:text-[15px]">
          <Link to={`/detail/${article.id}`} className="link-underline">
            {article.title}
          </Link>
        </h3>
      </div>
    </article>
  );
}